import { render, staticRenderFns } from "./CInfoTooltip.vue?vue&type=template&id=2b595dee&scoped=true&lang=pug&"
import script from "./CInfoTooltip.vue?vue&type=script&lang=js&"
export * from "./CInfoTooltip.vue?vue&type=script&lang=js&"
import style0 from "./CInfoTooltip.vue?vue&type=style&index=0&id=2b595dee&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b595dee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
